export default "__VITE_ASSET__CP8fnpP9__"